module.exports = {
  APP_VERSION_MAJOR: 7, // Max is 99
  APP_VERSION_MINOR: 1, // Max is 99
  APP_VERSION_PATCH: 9, // Max is 99
  BUILD_VERSION: 4, // Max is 999
};
